import axios from "axios";
import { API_URL } from "../config/constants";

// const API_URL = "http://localhost:5000/api/auth/";

const END_POINT = `${API_URL}users/`

// export const ImagePath="D:/IboostPatientHealthcare/iboosthealthcare0703/server/uploaded_images/"
// export const ImagePath="http://localhost:5000/uploaded_images/"
export const FolderPath = "http://localhost:5000"
export const ImagePath = `${FolderPath}/`

export const getAllCrud = (page) => {
    try {
        // const token = localStorage.getItem('jwtToken');
        // if (!token) {
        //     console.log("Token missing!");
        //     return null;
        // }
        console.log('page getAllCrud', page)
        return axios.get(`${END_POINT}userget?page=${page}`,
            //     {
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //     },
            // }
        );
    } catch (error) {
        console.error("Error fetching setting:", error);
        return null;
    }
};
// export const forgotpassword = (email: string) => {
//   return axios
//     .post(API_URL + "forgot-password", {
//       email

//     })
//     .then((response) => {


//       return response?.data;
//     });
// };

// export const resetpassword = (confirmpassword: string, url: string) => {
//   return axios
//     .post(API_URL + "emailrecover-password", {
//       confirmpassword,
//       url

//     })
//     .then((response) => {


//       return response?.data;
//     });
// };

export const logout = () => {
    localStorage.removeItem("user");
};


export const deleteUser = (id) => {
    return axios
        .delete(`${END_POINT}userdelete/${id}`)
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const getOneUser = (id) => {
    return axios
        .get(`${END_POINT}usergetoneuser/${id}`)
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const addingUser = (name, email, phone, password, confirmPassword) => {

    return axios
        .post(`${END_POINT}usercreatelogin`, { name, email, phone, password, confirmPassword })
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const updateUser = (id, name, email, phone) => {
    return axios
        .put(`${END_POINT}userupdatedate/${id}`,
            { name, email, phone }
        )
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const fetchKYC = (page) => {
      const token = localStorage.getItem('jwtToken');
                if (!token) {
                    console.log("Token missing!");
                    return null;
                }
    return axios
        .get(`${END_POINT}fetch-KYC-requests?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const updateKYC = (id, status) => {
    return axios
        .put(`${END_POINT}update-KYC-request/${id}`,
            { status }
        )
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const deleteKYC = (id) => {
    return axios
        .get(`${END_POINT}delete-KYC/${id}`)
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};